const config = {
  apiUrl: "http://api",
};

export default config;



// WEBPACK FOOTER //
// ./src/config/kubernetes-local.js